import { observer } from 'mobx-react';
import TearsheetDesktopView from './DesktopView/TearsheetDesktopView';
import TearsheetMobileView from './MobileView/TearsheetMobileView';
import React from 'react';
import store from 'stores/RootStore';

function Tearsheet() {
  const { isMobile } = store.ui;
  return isMobile ? <TearsheetMobileView /> : <TearsheetDesktopView />;
}

export default observer(Tearsheet);
